exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Ambassadors-module__wrapper___2fBDp{display:grid;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));gap:1.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "Ambassadors-module__wrapper___2fBDp"
};